export const IS_USER_LOGGED_IN = 'IS_USER_LOGGED_IN'
export const USER_LOGGED_IN = 'USER_LOGGED_IN'
export const APP_DRAWER_STATE = 'APP_DRAWER_STATE'
export const SHOW_ERROR_RESPONSE_DIALOG = 'SHOW_ERROR_RESPONSE_DIALOG'
export const ERROR_RESPONSE_DIALOG_DATA = 'ERROR_RESPONSE_DIALOG_DATA'
export const MENU_OFFER = 'MENU_OFFER'
export const DAILY_MENU_OFFER = 'DAILY_MENU_OFFER'
export const DAILY_MENU_TOP_GROUP_OFFER = 'DAILY_MENU_TOP_GROUP_OFFER'
export const DAILY_MENU_TOP_GROUP_CHANGE_SET = 'DAILY_MENU_TOP_GROUP_CHANGE_SET'
export const DAILY_MENU_TOP_GROUP_SAVED = 'DAILY_MENU_TOP_GROUP_SAVED'
export const IS_DATA_CHANGED = 'IS_DATA_CHANGED'
export const IS_MOBILE = 'IS_MOBILE'
export const DAILY_MENU_CHANGE_SET = 'DAILY_MENU_CHANGE_SET'
export const SELECTED_VIEW = 'SELECTED_VIEW'
export const LOADING_DAILYMENU = 'LOADING_DAILYMENU'
export const CURRENT_USER_RESERVATION_RANGE_DATA = 'CURRENT_USER_RESERVATION_RANGE_DATA'
export const USER_SETTINGS_4_ORDERING = 'USER_SETTINGS_4_ORDERING'
export const IS_PROFILE_DIALOG_SHOW = 'IS_PROFILE_DIALOG_SHOW'
export const AUTH_TOKEN = 'AUTH_TOKEN'
export const IS_INVALID_TOKEN = 'IS_INVALID_TOKEN'
export const GET_SELECTED_MENU_ITEM = 'GET_SELECTED_MENU_ITEM'
export const IS_ORDER_CONFIRMATION = 'IS_ORDER_CONFIRMATION'
export const IS_DELETE_CONFIRMATION = 'IS_DELETE_CONFIRMATION'

//<editor-fold desc="Settings module getters">
export const SETTINGS_ALL = 'SETTINGS_ALL'
//</editor-fold>

//<editor-fold desc="Navigation module getters">
export const NAVIGATION_DRAWER_ITEMS = 'NAVIGATION_DRAWER_ITEMS'
//</editor-fold>

export const GET_CALENDAR_EVENTS = 'GET_EVENTS'

export const IS_DEBTOR = 'IS_DEBTOR'
export const GET_CONFIG = 'GET_CONFIG'

export const GET_MODE = 'GET_MODE'
export const GET_SHOW_CONTROL_BUTTONS_MODE = 'GET_SHOW_CONTROL_BUTTONS_MODE'

export const GET_CID = 'GET_CID'
export const GET_TT = 'GET_TT'
export const GET_SHOW_LOGOUT_BUTTON_MODE = 'GET_SHOW_LOGOUT_BUTTON_MODE'
export const GET_SHOW_LOGOUT_TIMER_MODE = 'GET_SHOW_LOGOUT_TIMER_MODE'
export const SUPPORTED_LANGUAGES = 'SUPPORTED_LANGUAGES'
export const CURRENT_UI_LANGUAGE = 'CURRENT_UI_LANGUAGE'